import { Component, Input, OnInit } from '@angular/core';
import { ApThreadMessageDto } from 'webcommon/shared';
import { ApBaseComponent } from 'webcommon/core-ui';

@Component({
  selector: 'ap-message-thread',
  styleUrls: ['./ap-message-thread.component.less'],
  templateUrl: './ap-message-thread.component.html',
})
export class ApMessageThreadComponent extends ApBaseComponent implements OnInit {
  @Input() baseId?: string;
  @Input() messageThread: ApThreadMessageDto[];

  Id: string;

  messageList: string[];

  constructor() {
    super();
  }

  ngOnInit() {
    this.setId();
    this.load();
  }

  private load() {
    this.loading = false;
  }

  private setId() {
    this.Id = `${this.baseId}-thread`;
  }
}
